var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "empty-text": _vm.emptyText,
            data: _vm.rows,
            "element-loading-text": _vm.$tableLoading,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255,255,255,0)",
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeight,
            border: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", align: "center", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              fixed: "left",
              label: "STT",
              width: "55",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Họ tên", "min-width": "220", fixed: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("div", [
                            _vm._v(
                              "Họ tên: " +
                                _vm._s(
                                  scope.row.kidName || scope.row.fullName || "-"
                                )
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              "Bố/Mẹ: " + _vm._s(scope.row.buyerName || "-")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "block",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            "max-width": "200px",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.kidName || scope.row.fullName || "-"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Lớp", prop: "className", width: "200" },
          }),
          _c("el-table-column", {
            attrs: { label: "Mã học sinh", prop: "kidCode", width: "130" },
          }),
          _c("el-table-column", {
            attrs: { label: "Mã Onekids", prop: "orderKidCode", width: "200" },
          }),
          _c("el-table-column", {
            attrs: { label: "Ngày tạo", width: "190", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatDateTime(
                            scope.row.createdAt || scope.row.issuedAt
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Phương thức TT", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.paymentMethodName || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Thanh toán", width: "130", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color: scope.row.paymentStatus
                            ? "#1e88e5"
                            : "#fb8c00",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.paymentStatus ? "Đã TT" : "Chưa TT"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tổng tiền không chịu thuế",
              prop: "totalAmountWithoutTax",
              align: "right",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatCurrency(scope.row.totalAmountWithoutTax)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tổng tiền chịu thuế",
              prop: "totalTaxAmount",
              align: "right",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatCurrency(scope.row.totalTaxAmount)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tổng tiền",
              prop: "totalAmountWithTax",
              align: "right",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatCurrency(scope.row.totalAmountWithTax)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trạng thái", width: "170", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color: _vm.statusColor(
                            scope.row.invoiceStatus || scope.row.status
                          ),
                          fontWeight: 500,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.statusLabel(
                                scope.row.invoiceStatus || scope.row.status
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              fixed: "right",
              align: "center",
              width: "210",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Chỉnh sửa", placement: "top" } },
                      [
                        scope.row.invoiceStatus === "ONEKIDS_DRAFT"
                          ? _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "info",
                                circle: "",
                                icon: "el-icon-edit",
                                loading: _vm.actionLoading.edit,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.editDraft(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: { content: "Xem trước nháp", placement: "top" },
                      },
                      [
                        _c("el-button", {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            circle: "",
                            icon: "el-icon-view",
                            loading: _vm.actionLoading.preview,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.previewDraft(scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Lập HĐ nháp trên S-Invoice",
                          placement: "top",
                        },
                      },
                      [
                        scope.row.invoiceStatus === "ONEKIDS_DRAFT"
                          ? _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "warning",
                                circle: "",
                                icon: "el-icon-document-copy",
                                loading: _vm.actionLoading.draft,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.promptCreateDraft(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Phát hành HĐ", placement: "top" } },
                      [
                        _vm.checkPermission(["send-tax-authority"]) &&
                        _vm.getSinvoiceConfigField(
                          "usbDigitalSignature",
                          false
                        ) === false
                          ? _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "success",
                                circle: "",
                                icon: "el-icon-upload2",
                                loading: _vm.actionLoading.issue,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.issueInvoice(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xác nhận",
            visible: _vm.confirmIssueDialogVisible,
            width: "420px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmIssueDialogVisible = $event
            },
          },
        },
        [
          _c("div", [_vm._v("Bạn có chắc chắn muốn phát hành hóa đơn không?")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmIssueDialogVisible = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmIssueAction },
                },
                [_vm._v("Đồng ý")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xác nhận",
            visible: _vm.confirmCreateDraftDialogVisible,
            width: "450px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmCreateDraftDialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _vm._v(
              "Bạn có chắc chắn muốn lập hóa đơn nháp cho hóa đơn này không?"
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmCreateDraftDialogVisible = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmCreateDraft },
                },
                [_vm._v("Đồng ý")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }